/**
 * The real shape of a room: its outline, what is fixed inside it, and where
 * the doors and windows are. Stored on `Room.shape`; the flat `perimeterPoints`
 * and the `widthFt` × `heightFt` box are derived from it on save, so everything
 * that only knew a rectangle or a polygon (the canvas, the 3D view, the setup
 * PDF, the client portal) keeps working and simply receives the real outline.
 *
 * Coordinates are feet, x to the right and y **down** — the plan's own axes.
 */
export const ROOM_FEATURE_KINDS = [
    'PILLAR',
    'BAR',
    'STAGE',
    'DANCE_FLOOR',
    'RAISED',
    'SUNKEN',
    'NO_GO',
];
export const ROOM_FEATURE_LABELS = {
    PILLAR: 'Pillar',
    BAR: 'Built-in bar',
    STAGE: 'Built-in stage',
    DANCE_FLOOR: 'Fixed dance floor',
    RAISED: 'Raised area',
    SUNKEN: 'Sunken area',
    NO_GO: 'Keep clear',
};
/** Features nothing can be placed on — they come off the room's usable area. */
export const BLOCKING_FEATURE_KINDS = [
    'PILLAR',
    'BAR',
    'STAGE',
    'NO_GO',
];
export const ROOM_OPENING_KINDS = [
    'DOOR',
    'DOUBLE_DOOR',
    'FIRE_EXIT',
    'SERVICE',
    'WINDOW',
];
export const ROOM_OPENING_LABELS = {
    DOOR: 'Door',
    DOUBLE_DOOR: 'Double door',
    FIRE_EXIT: 'Fire exit',
    SERVICE: 'Service entrance',
    WINDOW: 'Window',
};
export const ROOM_SHAPE_PRESETS = [
    'RECTANGLE',
    'L_SHAPE',
    'U_SHAPE',
    'T_SHAPE',
    'CUT_CORNERS',
    'ROUNDED_END',
    'CIRCLE',
];
//# sourceMappingURL=room-shape.js.map